import { useContext } from "react";

import { StartStepWrapper } from "./Start.style";
import { Button } from "../../components/Button";
import { AppContext } from "../../App.context";
import { STEPS } from "../../App";

const QUIZ_LEVEL = [
  {
    name: "Łatwy",
    postId: "7249",
  },
  {
    name: "Trudny",
    postId: "7251",
  },
];

export const StartStep = () => {
  const { changeStep, changePostId } = useContext(AppContext);

  const handleClick = (postId) => () => {
    changePostId(postId);
    changeStep(STEPS.QUESTIONS);
  };

  return (
    <StartStepWrapper>
      <div>
        <p>
          Quiz o województwie śląskim pozwala Ci sprawdzić swoją wiedzę na temat
          naszego województwa. Obejmuje wiele dziedzin, między innymi historię,
          geografię, literaturę, a także bieżące wydarzenia polityczne i
          kulturalne.
        </p>
        <p>
          Quiz ma dwa poziomy trudności - łatwy i trudny. Ten pierwszy
          skierowany jest przede wszystkim do dzieci na poziomie szkoły
          podstawowej, drugi do uczniów szkół licealnych, policealnych,
          studentów i wszystkich innych, którzy chcieliby zmierzyć się z
          pytaniami na poziomie akademickim.
        </p>
        <p>
          Po rozpoczęciu quizu odpowiadamy na dziesięć losowo wybranych pytań.
          Poprawne odpowiedzi będą zaznaczone na zielono, a błędne na czerwono.
          Po udzieleniu wszystkich dziesięciu odpowiedzi pojawi się punktacja
          pozwalająca ocenić naszą wiedzę.
        </p>
      </div>
      <div>
        {QUIZ_LEVEL.map((level) => (
          <Button key={level.postId} onClick={handleClick(level.postId)}>
            {level.name}
          </Button>
        ))}
      </div>
    </StartStepWrapper>
  );
};
